import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sprite_icon__insert-question",
  "use": "icon-sprite_icon__insert-question-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-sprite_icon__insert-question\"><path d=\"M36 4v56h56V29.6L82 40.8V50H46V14h25l8.8-10zm52.8 2L65.6 32.2l-10.2-9.6-6.8 7.2 17.6 16.8 30-33.8zM36 68v56h56V68zm10 10h36v36H46z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol